import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useModel } from '../../hooks';
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: {
      default: 0
    },
    valArr: {
      default: () => [0, 1]
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const checked = useModel(() => props.modelValue, val => emit('update:modelValue', val));
    const handleChange = val => {
      if (val !== props.modelValue) {
        emit('change', val);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");
      return _openBlock(), _createBlock(_component_el_switch, _mergeProps({
        modelValue: _unref(checked),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(checked) ? checked.value = $event : null),
        "active-value": __props.valArr[1],
        "inactive-value": __props.valArr[0]
      }, _ctx.$attrs, {
        onChange: handleChange
      }), null, 16, ["modelValue", "active-value", "inactive-value"]);
    };
  }
});